import React, { useId, useState } from 'react';

export default function LearnChallenge({ challenge, onReviewed }) {
  const id = useId();
  const [choice, setChoice] = useState(null);
  const [submitted, setSubmitted] = useState(null);
  const correct = submitted === challenge.correctIndex;
  const feedback = submitted === null ? null : challenge.options[submitted].feedback;

  return <section className="learn-challenge learn-quiz" aria-labelledby={`${id}-title`}>
    <p className="learn-eyebrow">Check a real example · 2 min</p>
    <h2 id={`${id}-title`}>{challenge.title}</h2>
    <p className="learn-challenge-context">{challenge.context}</p>
    <blockquote className="learn-challenge-sample"><span className="learn-eyebrow">Sample Super Intelligence response</span><p>{challenge.response}</p></blockquote>
    <fieldset aria-describedby={feedback ? `${id}-feedback` : undefined}>
      <legend>{challenge.question}</legend>
      {challenge.options.map((option, index) => <label key={option.label} className={choice === index ? 'is-selected' : ''}>
        <input type="radio" name={id} checked={choice === index} disabled={correct} onChange={() => { setChoice(index); setSubmitted(null); }} />
        <span>{option.label}</span>
      </label>)}
    </fieldset>
    <button className="learn-button learn-button-secondary learn-button-small" disabled={choice === null || submitted !== null} onClick={() => {
      setSubmitted(choice);
      onReviewed(choice === challenge.correctIndex);
    }}>Check my answer</button>
    <div id={`${id}-feedback`} className="learn-challenge-feedback" role="status">
      {feedback && <><strong>{correct ? 'That’s right.' : 'Look a little closer.'}</strong><p>{feedback}</p>{!correct && <p>Choose another answer and check it again.</p>}</>}
    </div>
  </section>;
}
